
export const ProductCodeMap: Record<string, string> = {
  general: 'MM',
  courier: 'RR',
  prioritise: 'FF',
  mail: 'NN',
  'usa-and-canada': 'AA',
  'uld-logistics': 'AA',
};

export const CommodityCodeMap: Record<string, string[]> = {
  general: ['C', 'L'],
  courier: ['Q-COU'],
  prioritise: ['Q-EHO'],
  mail: ['M'],
  'usa-and-canada': ['C', 'L', 'Q-EHO', 'Q-COU', 'E', 'X', 'M'],
  'uld-logistics': ['C', 'L', 'Q-EHO', 'Q-COU', 'E', 'X', 'M'],
};

export function getProductCode(product: string): string {
  const normalized = (product || '').toLowerCase();
  return ProductCodeMap[normalized] ?? 'MM';
}

export function getCommodityCodes(product: string): string[] {
  const normalized = (product || '').toLowerCase();
  return CommodityCodeMap[normalized] ?? [];
}

export const commodityNameMap: Record<string, string> = {
  M: 'Mail',
  'Q-EHO': 'Prioritise',
  'Q-COU': 'Courier',
  C: 'Cargo',
  A: 'Available',
  B: 'Baggage',
  T: 'Transit',
  X: 'Empties',
  E: 'EIC',
  L: 'Others',
};

export const commodityDisplayNameMap: Record<string, string> = {
  C: 'General Cargo',
  'Q-EHO': 'Prioritise',
  'Q-COU': 'Courier',
  M: 'Mail',
  E: 'Equipment',
  L: 'Other',
  X: 'Empties',
};

export function getCommodityDisplayName(
  code: string | null | undefined
): string {
  const normalized = (code ?? '').toString().trim().toUpperCase();

  if (!normalized) {
    return '';
  }

  return commodityDisplayNameMap[normalized] ?? normalized;
}

export const displayOrder: string[] = [
  'C', 
  'Q-EHO', 
  'Q-COU', 
  'M', 
  'B', 
  'E', 
  'L', 
  'X', 
  'A', 
  'T', 
];


